// extracted by mini-css-extract-plugin
export default {"reviewsList":"ReviewsList_reviewsList__S79vI","iconBox":"ReviewsList_iconBox__U4ruo","title":"ReviewsList_title__4ki8I"};